import { TripService, TripRecommendation } from './generated';
import { OpenAPI } from './generated/core/OpenAPI';

// Set the base URL for the OpenAPI client
OpenAPI.BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const tripService = {
  sendMessage: async (message: string) => {
    const response = await TripService.getTripRecommendationsApiV1TripRecommendationsPost({
      requestBody: {
        prompt: message
      }
    });
    return response;
  },
};

export type { TripRecommendation };